export default __webpack_public_path__ + "static/media/parental-control-app-circle.c6f73bcb.png";